import {useState, useEffect, useRef} from 'react';
import {isEqual, isNil} from 'lodash-es';

export const useChangeHandler = <T>(property: T, callback: (previous: T) => void) => {
  const latestCallback = useRef<(previous: T) => void>();
  const [currentState, setCurrentState] = useState<T>(property);

  useEffect(
    () => {
      latestCallback.current = callback;
    },
    [callback]
  );

  useEffect(
    () => {
      if (isNil(property)) {
        return;
      }

      if (isEqual(property, currentState)) {
        return;
      }

      callback(currentState);
      setCurrentState(property);
    },
    [currentState, setCurrentState, property]
  );
};
